import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Grid, Paper } from '@material-ui/core';

import Table from 'pages/Dashboard/components/Table';
import Header from 'pages/Dashboard/components/Header';
import Section from 'components/Section';
import { useDispatch } from 'react-redux';
import { setModal } from 'redux/slices/modalSlice';
import { MODAL_TYPES } from 'config';
import { cancelOne } from 'redux/slices/dataSlice';
import useConfirmationModal from 'utils/hooks/useConfirmationModal';

const StyledPaper = styled(Paper)`
  margin: .2rem 0 .2rem 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

const HeaderContainer = styled.div`
  padding: .5rem;
  margin-bottom: 0.8rem;
`;

function Dashboard() {
  const dispatch = useDispatch();
  const { getConfirmation } = useConfirmationModal();

  const handleView = useCallback(
    (id, rowData) => {
      dispatch(
        setModal({
          type: MODAL_TYPES.formModal,
          modalProps: {
            id,
            clientData: { ...rowData },
            readOnly: true,
          },
        })
      );
    },
    [dispatch]
  );
  const handleEdit = useCallback(
    (id, rowData) => {
      dispatch(
        setModal({
          type: MODAL_TYPES.formModal,
          modalProps: {
            id,
            clientData: { ...rowData },
          },
        })
      );
    },
    [dispatch]
  );
  const handleDownload = useCallback(
    (id, rowData) => {
      dispatch(
        setModal({
          type: MODAL_TYPES.viewClientModal,
          modalProps: {
            id,
            clientData: { ...rowData },
          },
        })
      );
    },
    [dispatch]
  );
  const handleCancel = useCallback(
    async (id) => {
      const modalProps = {
        message: 'Esta seguro que desea pasar esta operacion a "cancelado"?',
        btnCancel: 'Volver',
        btnConfirm: 'Cancelar operacion',
      };
      (await getConfirmation(modalProps)) && dispatch(cancelOne({ id }));
    },
    [dispatch, getConfirmation]
  );

  const handlers = {
    handleView,
    handleEdit,
    handleDownload,
    handleCancel,
  };
  return (
    <Section>
      <StyledPaper variant="outlined" elevation={2}>
        <Grid item>
          <HeaderContainer>
            <Header />
          </HeaderContainer>
        </Grid>
        <Grid item>
          <Table handlers={handlers} />
        </Grid>
      </StyledPaper>
    </Section>
  );
}

export default Dashboard;
